export function isUnauthorizedError(error: unknown): boolean {
	const seen = new Set<unknown>();
	let current: unknown = error;

	while (current && typeof current === 'object' && !seen.has(current)) {
		seen.add(current);
		const candidate = current as Record<string, unknown>;

		if (candidate.status === 401 || candidate.statusCode === 401) {
			return true;
		}

		const response = candidate.response;
		if (response && typeof response === 'object' && (response as Record<string, unknown>).status === 401) {
			return true;
		}

		current = candidate.cause;
	}

	return false;
}
